<div class="risk-tab" dir="rtl">
  <div *ngIf="loading" class="empty-box">
    <i class="fa fa-spinner fa-spin"></i>
    <span>در حال دریافت اطلاعات ریسک...</span>
  </div>

  <div *ngIf="!loading && !hasData" class="empty-box">
    <i class="fa fa-exclamation-triangle"></i>
    <span>داده‌ای برای تحلیل ریسک وجود ندارد</span>
  </div>

  <ng-container *ngIf="!loading && hasData">
    <div class="grid-2">
      <div class="box">
        <h3><i class="fa fa-th"></i> نقشه حرارتی مؤلفه‌های ریسک — 15 خودرو بحرانی</h3>
        <div class="chart-lg"><canvas id="riskHeatmap"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-pie-chart"></i> تفکیک خودروها بر اساس وضعیت و ریسک کل</h3>
        <div class="chart-lg"><canvas id="riskStack"></canvas></div>
      </div>
    </div>

    <div class="avg-strip">
      <div class="avg-item" *ngFor="let r of riskAvgs; trackBy: trackByAvg">
        <span class="dot" [style.background]="r.color"></span>
        <span class="lbl">{{ r.label }}</span>
        <b>{{ toEn(r.value) }}</b>
      </div>
    </div>

    <div class="grid-3 mt">
      <div class="box">
        <h3><i class="fa fa-tachometer"></i> میانگین ریسک سرعت بالا</h3>
        <div class="chart-sm"><canvas id="riskSpeed"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-arrow-down"></i> میانگین ریسک کاهش سرعت</h3>
        <div class="chart-sm"><canvas id="riskDecel"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-arrow-up"></i> میانگین ریسک شتاب‌گیری</h3>
        <div class="chart-sm"><canvas id="riskAccel"></canvas></div>
      </div>
    </div>

    <div class="grid-2 mt">
      <div class="box">
        <h3><i class="fa fa-repeat"></i> میانگین ریسک تکرار رفتار</h3>
        <div class="chart-sm"><canvas id="riskRep"></canvas></div>
      </div>
      <div class="box">
        <h3><i class="fa fa-road"></i> میانگین ریسک الگوی رانندگی</h3>
        <div class="chart-sm"><canvas id="riskPattern"></canvas></div>
      </div>
    </div>
  </ng-container>
</div>
